import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formatea un objeto Date a string YYYY-MM-DD preservando la fecha local.
 * Evita problemas de zona horaria que ocurren al usar toISOString().
 *
 * @param date - Objeto Date a formatear
 * @returns String en formato YYYY-MM-DD (ej: "2024-10-15")
 *
 * @example
 * const date = new Date(2024, 9, 15); // 15 de octubre de 2024
 * formatDateLocal(date); // "2024-10-15" (preserva fecha local)
 *
 * // Comparación con toISOString (INCORRECTO para fechas locales):
 * date.toISOString().split('T')[0]; // "2024-10-14" en UTC-5 ❌
 */
export function formatDateLocal(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Redondea una cantidad a número entero (sin decimales).
 * Útil para conversiones de unidades de medida donde se prefieren números enteros.
 *
 * @param qty - Cantidad a redondear
 * @returns Número redondeado sin decimales
 *
 * @example
 * roundQuantity(48.03); // 48
 * roundQuantity(48.5);  // 49
 * roundQuantity(48);    // 48
 */
export function roundQuantity(qty: number): number {
  return Math.round(qty);
}

/**
 * Formatea una cantidad redondeada como string.
 * Redondea a número entero y convierte a string.
 *
 * @param qty - Cantidad a formatear
 * @returns String con número redondeado
 *
 * @example
 * formatRoundedQty(48.03); // "48"
 * formatRoundedQty(48.5);  // "49"
 */
export function formatRoundedQty(qty: number): string {
  return Math.round(qty).toString();
}
